












import Vue from 'vue'
export default Vue.extend({
  name: 'AutocompleteField',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentValue: '',
      timeout: -1
    }
  },
  methods: {
    onValueChanged ($event: string) {
      if (this.timeout !== -1) {
        clearTimeout(this.timeout)
      }
      setTimeout(() => {
        this.$emit('input', $event)
      }, 500)
    }
  }
})
